module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ca0Dj"))).then(() => parcelRequire('1iHdE'));